import React, { ReactElement, useState, useEffect } from "react";
import {
  signInWithEmail,
  sendEmailVerification,
  auth,
  onSnapshotRegistrationSettings,
  uploadFileToStorage,
} from "../../apis/firebase";

import { Link, useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { useFormik } from "formik";

import { useSelector, shallowEqual } from "react-redux";

import * as Yup from "yup";

import Select from "react-select";

import axios from "axios";

let snapshotRef = null;

const SignUp = (): ReactElement => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formErrorMessage, setFormErrorMessage] = useState("");
  const [hidePassword, setHidePassword] = useState(true);
  const [customFields, setCustomField] = useState<any>([]);
  const [passwordValidationStatus, setPasswordValidationStatus] = useState({
    upperCase: true,
    lowerCase: true,
    numbers: true,
    length: true,
    symbol: true,
  });

  const search = window.location.search;
  const query = new URLSearchParams(search);
  const tId = query.get("t") || "";

  const [registrationSettings, setRegistrationSettings] = useState();

  const { t } = useTranslation();

  const history = useHistory();

  const { generalSettings } = useSelector(
    ({ generalSettings }) => ({ generalSettings: generalSettings }),
    shallowEqual
  );

  useEffect(() => {
    snapshotRef = onSnapshotRegistrationSettings((dt) => {
      setRegistrationSettings({ ...dt });
      const { customFields: _customFields } = { ...dt };
      setCustomField(_customFields || []);
    });

    return () => snapshotRef();
  }, []);

  useEffect(() => {
    if (!!generalSettings && !generalSettings.registrationEnabled) {
      history.push("/login");
    }
  }, [generalSettings]);

  const initialValues = {
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    is_action: true,
    admin: false,
    acceptTerms: false,
  };

  Yup.addMethod(Yup.string, "emailDomainCheck", function (errorMessage) {
    return this.test(`test-email-domain`, errorMessage, function (value) {
      if (
        !generalSettings.authorisedDomainName ||
        generalSettings.authorisedDomainName === "" ||
        !value
      )
        return true;

      const domains = generalSettings.authorisedDomainName.split(",");
      let _flag = false;

      domains.forEach((domain) => {
        if (value.endsWith(domain.trim())) {
          _flag = true;
          return;
        }
      });

      return _flag;
    });
  });

  Yup.addMethod(Yup.string, "strongPassword", function (errorMessage) {
    return this.test("strongPasswordTest", errorMessage, function (value) {
      const { path, createError } = this;

      //   console.log("registrationSettings", registrationSettings);
      const passwordReq = generalSettings.passwordRequirements;

      let error = false;
      let _state = {
        upperCase: true,
        lowerCase: true,
        numbers: true,
        length: true,
        symbol: true,
      };
      if (!value) return false;

      if (!!passwordReq && passwordReq?.hasOwnProperty("length")) {
        if (value.length < passwordReq.length) {
          error = true;
        } else {
          _state = {
            ..._state,
            length: false,
          };
        }
      }
      if (!!passwordReq && passwordReq.lowerCase) {
        if (!/^(?=.*[a-z])/.test(value)) {
          error = true;
        } else {
          _state = {
            ..._state,
            lowerCase: false,
          };
        }
      }

      if (!!passwordReq && passwordReq.upperCase) {
        if (!/^(?=.*[A-Z])/.test(value)) {
          error = true;
        } else {
          _state = {
            ..._state,
            upperCase: false,
          };
        }
      }

      if (!!passwordReq && passwordReq.numbers) {
        if (!/^(?=.*[0-9])/.test(value)) {
          error = true;
        } else {
          console.log("m here");
          _state = {
            ..._state,
            numbers: false,
          };
        }
      }

      if (!!passwordReq && passwordReq.symbols) {
        if (!/^(?=.*[!@#\$%\^&\*])/.test(value)) {
          error = true;
        } else {
          _state = {
            ..._state,
            symbol: false,
          };
        }
      }
      // console.log(_state);
      setPasswordValidationStatus(_state);

      if (error) {
        return createError({
          path,
          message: "",
        });
      }

      return true;
    });
  });

  const formValidatorObject = {
    email: Yup.string()
      .email(t("FORM_EMAIL_VALIDATION_FORMAT"))
      .required(t("FORM_REQUIRED_FIELD"))
      .emailDomainCheck(t("FORM_EMAIL_VALIDATION_DOMAIN")),
    firstName: Yup.string().required(t("FORM_REQUIRED_FIELD")),
    lastName: Yup.string().required(t("FORM_REQUIRED_FIELD")),
    password: Yup.string().required(t("FORM_REQUIRED_FIELD")).strongPassword(),
    acceptTerms: Yup.bool().oneOf([true]),
  };

  if (!!customFields?.length) {
    customFields.forEach((d) => {
      initialValues[d.fieldName] = "";
      let _req: any;
      switch (d.type) {
        case "text":
          if (d.validationCriteria.required) {
            _req = Yup.string().required(t("FORM_REQUIRED_FIELD"));
          }
          break;
        case "checkbox":
          if (d.validationCriteria.required) {
            _req = Yup.string().required(t("FORM_REQUIRED_FIELD"));
          }
          break;
        case "file":
          if (d.validationCriteria.required) {
            _req = Yup.string().required(t("FORM_REQUIRED_FIELD"));
          }
          break;
        case "select":
          if (d.selectSize > 1) {
            _req = Yup.array().of(
              Yup.string().required(t("FORM_REQUIRED_FIELD"))
            );
          } else if (d.validationCriteria.required) {
            _req = Yup.string().required(t("FORM_REQUIRED_FIELD"));
          }
          break;
      }
      formValidatorObject[d.fieldName] = _req;
    });
  }

  const FormSchema = Yup.object().shape(formValidatorObject);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: FormSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const instance = axios.create();
        values["trackId"] = tId;

        if (customFields) {
          const _customFieldFileType = customFields?.find(
            (d) => d.type === "file"
          );
          if (_customFieldFileType && _customFieldFileType?.fieldName) {
            values[_customFieldFileType?.fieldName + "_file"] =
              await uploadFileToStorage(
                values[_customFieldFileType?.fieldName],
                values[_customFieldFileType?.fieldName].name
              );
            delete values[_customFieldFileType?.fieldName];
          }
        }
        const resp = await instance.post(`/users/register`, values);

        if (resp.status === 200) {
          if (resp.data.status) {
            if (resp.data.enforceVerifyEmail) {
              setIsSubmitted(true);
              await signInWithEmail(values.email, values.password);
              await sendEmailVerification(auth.currentUser);
            } else {
              await signInWithEmail(values.email, values.password);
            }

            window.localStorage.setItem("emailForSignIn", values.email);
          } else {
            if (resp.data.message?.code === "auth/email-already-exists") {
              setFormErrorMessage(t("ERROR_REGISTER_EMAIL_ALREADY_EXIST"));
            }
          }
        } else {
          alert(resp.data.message);
        }
      } catch (e) {
        console.log(e);
        if (e === "auth/email-already-in-use") {
          setFormErrorMessage(t("ERROR_REGISTER_EMAIL_ALREADY_EXIST"));
        }
        if (e === "auth/weak-password") {
          setFormErrorMessage(t("ERROR_REGISTER_CHOOSE_STRONG_PASSWORD"));
        }
      }
    },
  });

  return (
    <div className="d-flex flex-column mb-4">
      {!!isSubmitted && (
        <div className="mb-3">
          <div
            dangerouslySetInnerHTML={{
              __html: t("REGISTER_AFTER_SUBMIT_DESCRIPTION"),
            }}
          />
          {/* <h1 className="mb-2">We need to validate your email address.</h1>
            <p className="m-0">
              You will receive a message from us with a link that will allow you
              to confirm we have the right email address and let you join the
              event.
            </p>

            <p className="m-0 mt-3">
              If you don't see the email in your inbox, check your spam folder.
            </p> */}
        </div>
      )}
      {!isSubmitted && (
        <>
          <div className="mb-3">
            <div className="d-flex align-items-start justify-content-between">
              <h1 className="mb-2">{t("REGISTER_TITLE")}</h1>
            </div>
            <p className="m-0">{t("REGISTER_DESCRIPTION")}</p>
          </div>
          <form onSubmit={formik.handleSubmit}>
            {formErrorMessage && (
              <div className="alert alert-danger py-1 px-2 fs-7" role="alert">
                <i className="bi bi-exclamation-circle-fill me-1"></i>
                <span
                  dangerouslySetInnerHTML={{
                    __html: formErrorMessage,
                  }}
                />
              </div>
            )}

            <div className="mb-3">
              <input
                type="text"
                name="firstName"
                className={`form-control ${
                  formik.errors.firstName ? "is-invalid" : ""
                }`}
                placeholder={t("FORM_FIRST_NAME")}
                {...formik.getFieldProps("firstName")}
              />
              {formik.touched.firstName && formik.errors.firstName ? (
                <div className="invalid-feedback error-block">
                  {formik.errors.firstName}
                </div>
              ) : null}
            </div>
            <div className="mb-3">
              <input
                type="text"
                name="lastName"
                className={`form-control ${
                  formik.errors.lastName ? "is-invalid" : ""
                }`}
                placeholder={t("FORM_LAST_NAME")}
                {...formik.getFieldProps("lastName")}
              />
              {formik.touched.lastName && formik.errors.lastName ? (
                <div className="invalid-feedback error-block">
                  {formik.errors.lastName}
                </div>
              ) : null}
            </div>
            <div className="mb-3">
              <input
                type="email"
                name="email"
                className={`form-control ${
                  formik.errors.email ? "is-invalid" : ""
                }`}
                placeholder={t("FORM_EMAIL_PLACEHOLDER")}
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="invalid-feedback error-block">
                  {formik.errors.email}
                </div>
              ) : null}
            </div>

            <div className="mb-3">
              <div className="input-group">
                <input
                  type={hidePassword ? "password" : "text"}
                  placeholder={t("FORM_PASSWORD_PLACEHOLDER")}
                  className={`form-control ${
                    formik.errors.password ? "is-invalid" : ""
                  }`}
                  {...formik.getFieldProps("password")}
                />
                <div className="input-group-text">
                  <button
                    type="button"
                    className="bi bi-eye-fill"
                    onClick={() => {
                      setHidePassword(!hidePassword);
                    }}
                  />
                </div>
              </div>

              {generalSettings?.passwordRequirements && (
                <div className="tm__password-requirement mt-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <label className="fs-7 fw-bold mb-1">
                      {t("REGISTRATION_PASSWORD_REQUIREMENT_LABEL")}
                    </label>
                    {!passwordValidationStatus.length &&
                    !passwordValidationStatus.lowerCase &&
                    !passwordValidationStatus.upperCase &&
                    !passwordValidationStatus.numbers &&
                    !passwordValidationStatus.symbol ? (
                      <i className="bi bi-check-circle-fill text-success"></i>
                    ) : (
                      <div className="" role="status">
                        {/* <span className="visually-hidden">Loading...</span> */}
                      </div>
                    )}
                  </div>
                  <ul className="list-style-none m-0 p-0">
                    {generalSettings?.passwordRequirements?.length && (
                      <li
                        className={`${
                          !passwordValidationStatus.length ? `text-success` : ``
                        }`}>
                        <i className="bi bi-check-circle me-1"></i>
                        <span>
                          {t(
                            "FORM_PASSWORD_REQUIREMENT_CHARACTER_LENGTH"
                          ).replace(
                            "{$length}",
                            generalSettings?.passwordRequirements?.length
                          )}
                        </span>
                      </li>
                    )}
                    {generalSettings?.passwordRequirements?.lowerCase && (
                      <li
                        className={`${
                          !passwordValidationStatus.lowerCase
                            ? `text-success`
                            : ``
                        }`}>
                        <i className="bi bi-check-circle me-1"></i>
                        <span>{t("FORM_PASSWORD_REQUIREMENT_LOWERCASE")}</span>
                      </li>
                    )}
                    {generalSettings?.passwordRequirements?.upperCase && (
                      <li
                        className={`${
                          !passwordValidationStatus.upperCase
                            ? `text-success`
                            : ``
                        }`}>
                        <i className="bi bi-check-circle me-1"></i>
                        <span>{t("FORM_PASSWORD_REQUIREMENT_UPPERCASE")}</span>
                      </li>
                    )}
                    {generalSettings?.passwordRequirements?.numbers && (
                      <li
                        className={`${
                          !passwordValidationStatus.numbers
                            ? `text-success`
                            : ``
                        }`}>
                        <i className="bi bi-check-circle me-1"></i>
                        <span>{t("FORM_PASSWORD_REQUIREMENT_NUMBERS")}</span>
                      </li>
                    )}
                    {generalSettings?.passwordRequirements?.symbols && (
                      <li
                        className={`${
                          !passwordValidationStatus.symbol ? `text-success` : ``
                        }`}>
                        <i className="bi bi-check-circle me-1"></i>
                        <span>{t("FORM_PASSWORD_REQUIREMENT_CHARACTERS")}</span>
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </div>

            {!!customFields?.length &&
              customFields.map((d, i) => (
                <div key={i} className="mb-3">
                  <div className="input-group ">
                    {(d.type === "text" ||
                      d.type === "number" ||
                      d.type === "email") && (
                      <input
                        type={d.type}
                        placeholder={d.placeholder}
                        className={`form-control ${
                          formik.errors[`${d.fieldName}`] ? "is-invalid" : ""
                        }`}
                        {...formik.getFieldProps(`${d.fieldName}`)}
                      />
                    )}

                    {d.type === "file" && (
                      <input
                        type={d.type}
                        id="files"
                        className={`form-control  ${
                          formik.errors[`${d.fieldName}`] ? "is-invalid" : ""
                        }`}
                        onChange={(event) => {
                          const files = event.target.files[0];
                          formik.setFieldValue(`${d.fieldName}`, files);
                        }}
                      />
                    )}

                    {d.type === "checkbox" && (
                      <div className="d-flex flex-wrap align-items-center ">
                        <input
                          type={d.type}
                          placeholder={d.placeholder}
                          className={`form-check-input  ${
                            formik.errors.hasOwnProperty(`${d.fieldName}`)
                              ? "is-invalid"
                              : ""
                          }`}
                          {...formik.getFieldProps(`${d.fieldName}`)}
                        />
                        <label className="fs-7 form-check-label ms-2">
                          {d.label}
                        </label>
                      </div>
                    )}

                    {d.type === "select" &&
                      (!d.selectSize || d.selectSize === 1) && (
                        <Select
                          className={`custom-select col-12 ${
                            formik.errors[`${d.fieldName}`] ? "is-invalid" : ""
                          }`}
                          options={d.options}
                          placeholder={d.label}
                          onChange={(v) => {
                            formik.setFieldValue(`${d.fieldName}`, v.value);
                          }}
                        />
                      )}

                    {d.type === "select" &&
                      (!d.selectSize || d.selectSize > 1) && (
                        <Select
                          className={`custom-select col-12 ${
                            formik.errors[`${d.fieldName}`] ? "is-invalid" : ""
                          }`}
                          options={d.options}
                          isMulti
                          placeholder={d.label}
                          onChange={(value) => {
                            formik.setFieldValue(
                              `${d.fieldName}`,
                              value?.map((d) => d.value)
                            );
                          }}
                        />
                      )}
                    {formik.touched[`${d.fieldName}`] &&
                    formik.errors[`${d.fieldName}`] ? (
                      <div className="invalid-feedback error-block">
                        {formik.errors[`${d.fieldName}`]}
                      </div>
                    ) : null}
                  </div>
                </div>
              ))}

            <div className="d-flex flex-wrap align-items-center mb-4">
              <input
                className={`form-check-input ${
                  formik.errors.hasOwnProperty("acceptTerms")
                    ? "is-invalid"
                    : ""
                }`}
                type="checkbox"
                onChange={(e) => {
                  formik.setFieldValue("acceptTerms", e.target.checked);
                }}
              />

              <label className="fs-7 form-check-label ms-2">
                <div dangerouslySetInnerHTML={{ __html: t("AGREE_TERMS") }} />
              </label>

              {/* {formik.errors.hasOwnProperty("acceptTerms") ? (
                <div className="invalid-feedback error-block">
                  {formik.errors.acceptTerms}
                </div>
              ) : null} */}
            </div>

            <div className="mt-2">
              <button type="submit" className="btn btn-primary fw-bold w-100">
                {t("FORM_BUTTON_REGISTER_LABEL")}
              </button>
            </div>
            <div className="mt-4">
              <Link to="/login" className="btn btn-secondary fw-bold w-100">
                {t("FORM_BUTTON_LOGIN_LABEL")}
              </Link>
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default SignUp;
